import {MailIcon, UsersIcon} from "@heroicons/react/outline";

export const teamPageTabs = [
  { name: "Team Members", icon: UsersIcon },
  { name: "Invited", icon: MailIcon },
];
